module.exports = __webpack_public_path__ + "img/rightcode.f9f67b42.png";